type PostHog = typeof import("posthog-js").default;

// Memoized so a deferred page-load init and an on-demand captureEvent() never double-init.
let posthogInitPromise: Promise<PostHog> | null = null;

export function ensurePostHogInitialized(): Promise<PostHog> {
  if (!posthogInitPromise) {
    posthogInitPromise = (async () => {
      const posthog = (await import("posthog-js")).default;
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY ? process.env.NEXT_PUBLIC_POSTHOG_KEY : "", {
        api_host: "/ph-ingest",
        ui_host: "https://eu.posthog.com",
        capture_pageview: "history_change",
        disable_session_recording: false,
        disable_surveys: true,
        enable_recording_console_log: false,
        enable_heatmaps: false,
        // oppref (ChatGPT ad click ID) isn't in PostHog's built-in campaign param list.
        custom_campaign_params: ["oppref"],
      });
      return posthog;
    })();
    posthogInitPromise.catch(() => {
      posthogInitPromise = null;
    });
  }
  return posthogInitPromise;
}

export async function captureEvent(eventName: string, properties?: Record<string, unknown>) {
  if (typeof window === "undefined") return;

  // capture() silently no-ops before init() completes, so this must be awaited.
  const posthog = await ensurePostHogInitialized();
  posthog.capture(eventName, properties);
}
